import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuizStatsComponent } from './quiz-stats.component';
import { LightImageModule } from '../light-image/light-image.module';
import { MotePipesModule } from '../../pipes/mote-pipes.module';
import { SvgIconModule } from '../svg-icon';
import { LoadingComponentModule } from '../loading/loading.module';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    { path: '', component: QuizStatsComponent }
];

@NgModule({
    declarations: [
        QuizStatsComponent
    ],
    imports: [
        CommonModule,
        LightImageModule,
        MotePipesModule,
        SvgIconModule,
        LoadingComponentModule,
        RouterModule.forChild(routes)
    ],
    exports: [
        QuizStatsComponent
    ]
})
export class QuizStatsModule { }
